export const MAX_PARTICIPANTS_PER_SESSION = 50;
